module.exports = __webpack_public_path__ + "static/img/qyztb.94c61ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/qyztb.jpg
// module id = tw47
// module chunks = 1